import React, { forwardRef } from 'react';
import { Placement, PopupMenu } from 'shared/components/ui/popup-menu';
import { InteractionType } from 'shared/types/data-type';
import { Task } from 'shared/types/task';

import { CompleteList } from './complete-list';
import { DateSubMenu } from './date-sub-menu';
import { DeadlineDeadlineSubMenu } from './deadline-deadline-sub-menu';
import { EditList } from './edit-list';
import { LifeCycleList } from './life-cycle-list';
import { LinkedItemSubMenu } from './linked-item-sub-menu';
import { PrioritySubMenu } from './priority-sub-menu';
import { ReminderTimeSubMenu } from './reminder-time-sub-menu';
import { TagsSubMenu } from './tags-sub-menu';
import { SubMenu } from './types';

export type TaskCardMultiSelectContextMenuProps = Omit<
  React.ComponentProps<typeof PopupMenu>,
  'children' | 'ref' | 'onOutside' | 'position' | 'interactionType'
> & { tasks: Task[]; onClose: () => void };

export const TaskCardMultiSelectContextMenu = forwardRef<
  HTMLDivElement,
  TaskCardMultiSelectContextMenuProps
>(({ tasks, onClose, ...rest }, ref) => {
  const [openSubMenu, setOpenSubMenu] = React.useState<SubMenu>();
  const menuProps = {
    ...rest,
    position: 'bottom-start' as Placement,
    interactionType: InteractionType.Task,
    onOutside: onClose,
  };

  return (
    <>
      {!openSubMenu && (
        <PopupMenu ref={ref} {...menuProps}>
          <CompleteList tasks={tasks} onClose={onClose} />
          <EditList tasks={tasks} openSubMenu={setOpenSubMenu} />
          <LifeCycleList tasks={tasks} onClose={onClose} />
        </PopupMenu>
      )}

      {openSubMenu === SubMenu.Priority && (
        <PrioritySubMenu tasks={tasks} onClose={onClose} {...menuProps} />
      )}

      {openSubMenu === SubMenu.LinkedItem && (
        <LinkedItemSubMenu tasks={tasks} onClose={onClose} {...menuProps} />
      )}

      {openSubMenu === SubMenu.DeadlineDeadline && (
        <DeadlineDeadlineSubMenu
          tasks={tasks}
          onClose={onClose}
          {...menuProps}
        />
      )}

      {openSubMenu === SubMenu.ReminderTime && (
        <ReminderTimeSubMenu tasks={tasks} onClose={onClose} {...menuProps} />
      )}

      {openSubMenu === SubMenu.Date && (
        <DateSubMenu tasks={tasks} onClose={onClose} {...menuProps} />
      )}

      {openSubMenu === SubMenu.Tags && (
        <TagsSubMenu tasks={tasks} onClose={onClose} {...menuProps} />
      )}
    </>
  );
});
